<template>
  <div>
    <el-form
        :key="form.type"
        :model="form"
        :rules="rules"
        ref="form"
        label-width="170px"
        class="infoForm"
        :disabled="dataState"
    >
      <div class="subTitle">基本信息</div>
      <hr class="hr">
      <template v-if="form.type === 2">
        <el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="姓名" prop="name">
              <el-input
                  aria-label="姓名"
                  aria-autocomplete="none"
                  clearable
                  placeholder="请填写姓名"
                  type="text"
                  v-model.trim="form.name"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="身份证号码" prop="developId">
              <el-input
                  aria-label="身份证号码"
                  aria-autocomplete="none"
                  clearable
                  maxlength="100"
                  placeholder="请填写身份证号码"
                  type="text"
                  v-model.trim="form.developId"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="证件有效起止时间" prop="developIdValidityStart">
              <el-date-picker
                  v-model="form.developIdValidityStart"
                  type="date"
                  value-format="timestamp"
                  placeholder="选择日期">
              </el-date-picker>
              至
              <el-date-picker
                  v-model="form.developIdValidityEnd"
                  type="date"
                  value-format="timestamp"
                  placeholder="选择日期">
              </el-date-picker>
              <div class="themeColor">有效期为“长期”时后一项为空</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <div class="flex">
              <el-form-item label="身份证" prop="developPositivePhoto">
                <el-upload
                    class="uploaderFile"
                    accept=".png, .PNG"
                    :action="configBaseURL+'/api/uploadFile'"
                    :data="{type:'developPhoto'}"
                    :show-file-list="false"
                    :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'developPositivePhoto')}"
                    :before-upload="beforeUpload"
                >
                  <img
                      v-if="form.developPositivePhoto"
                      class="file"
                      :src="form.developPositivePhoto"
                  />
                  <i v-else class="el-icon-plus icon idCardBackImg"></i>
                </el-upload>
              </el-form-item>
              <el-form-item prop="developNegativePhoto" label-width="10px">
                <el-upload
                    class="uploaderFile"
                    accept=".png, .PNG"
                    :action="configBaseURL+'/api/uploadFile'"
                    :data="{type:'developPhoto'}"
                    :show-file-list="false"
                    :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'developNegativePhoto')}"
                    :before-upload="beforeUpload"
                >
                  <img
                      v-if="form.developNegativePhoto"
                      class="file"
                      :src="form.developNegativePhoto"
                  />
                  <i v-else class="el-icon-plus icon IDcardFrontImg"></i>
                </el-upload>
              </el-form-item>
            </div>
            <el-form-item>
              <div class="themeColor">请上传证件正反面图片，图片格式为png，大小不能超过2M。</div>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-else>
        <el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="企业名称" prop="companyName">
              <el-input
                  aria-label="企业名称"
                  aria-autocomplete="none"
                  clearable
                  maxlength="100"
                  placeholder="请输入企业或公司名称"
                  type="text"
                  v-model.trim="form.companyName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="统一信用社会代码" prop="licinseNumber">
              <el-input
                  maxlength="30"
                  aria-label="统一信用社会代码"
                  aria-autocomplete="none"
                  clearable
                  placeholder="请输入统一信用社会代码"
                  type="text"
                  v-model.trim="form.licinseNumber"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type==1">
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="营业执照" prop="licinseNumberPhoto">
              <el-upload
                  class="uploaderFile"
                  accept=".png, .jpg, .PNG, .JPG"
                  :action="configBaseURL+'/api/uploadFile'"
                  :data="{type:'licinseNumberPhoto'}"
                  :show-file-list="false"
                  :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'licinseNumberPhoto')}"
                  :before-upload="beforeUpload"
              >
                <img v-if="form.licinseNumberPhoto" class="file" :src="form.licinseNumberPhoto"/>
                <i v-else class="el-icon-plus icon businessBeforeImg"></i>
              </el-upload>
              <div class="themeColor">图片支持jpg、png格式，大小不能超过2M。</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type==3">
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="统一社会信用代码证书" prop="licinseNumberPhoto">
              <el-upload
                  class="uploaderFile"
                  accept=".png, .jpg, .PNG, .JPG"
                  :action="configBaseURL+'/api/uploadFile'"
                  :data="{type:'licinseNumberPhoto'}"
                  :show-file-list="false"
                  :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'licinseNumberPhoto')}"
                  :before-upload="beforeUpload"
              >
                <img v-if="form.licinseNumberPhoto" class="file" :src="form.licinseNumberPhoto"/>
                <i v-else class="el-icon-plus icon businessBeforeImg"></i>
              </el-upload>
              <div class="themeColor">图片支持jpg、png格式，大小不能超过2M。</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type==4">
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="事业法人证书" prop="licinseNumberPhoto">
              <el-upload
                  class="uploaderFile"
                  accept=".png, .jpg, .PNG, .JPG"
                  :action="configBaseURL+'/api/uploadFile'"
                  :data="{type:'licinseNumberPhoto'}"
                  :show-file-list="false"
                  :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'licinseNumberPhoto')}"
                  :before-upload="beforeUpload"
              >
                <img v-if="form.licinseNumberPhoto" class="file" :src="form.licinseNumberPhoto"/>
                <i v-else class="el-icon-plus icon businessBeforeImg"></i>
              </el-upload>
              <div class="themeColor">图片支持jpg、png格式，大小不能超过2M。</div>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <el-row>
        <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
          <div class="flex">
            <el-form-item label="所属区域" prop="province" label-width="160px">
              <el-select v-model="form.province" placeholder="请选择" @change="selectProvince" style="width: 150px"
                         size="small">
                <el-option
                    v-for="(item,index) in provincearr"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="city" label-width="10px">
              <el-select v-model="form.city" placeholder="请选择" @change="selectcity" style="width: 150px;"
                         size="small">
                <el-option
                    v-for="(item,index) in cityarr"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="area" label-width="10px">
              <el-select v-model="form.area" placeholder="请选择" @change="selectCountry" style="width: 150px"
                         size="small">
                <el-option
                    v-for="(item,index) in regionarr"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
          <el-form-item label="通讯地址" prop="address">
            <el-input
                aria-label="通讯地址"
                aria-autocomplete="none"
                clearable
                placeholder="请填写实际通讯地址，填写格式：xx省xx市xx区xx号"
                type="text"
                v-model.trim="form.address"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 法人信息 -->
      <template v-if="form.type !== 2">
        <div class="subTitle">法人信息</div>
        <hr class="hr">
        <el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="法人姓名" prop="legalPersonName">
              <el-input
                  aria-label="法人姓名"
                  aria-autocomplete="none"
                  clearable
                  maxlength="20"
                  placeholder="请填写法人姓名"
                  type="text"
                  v-model.trim="form.legalPersonName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item prop="legalPersonCertificateType" label="法人证件类型">
              <el-select v-model="form.legalPersonCertificateType" :disabled="form.type !== 1" style="width: 100%"
                         placeholder="请选择法人证件类型" @change="changePersonType">
                <el-option v-for="item in legalTypeList" :key="item.id" :label="item.value" :value="String(item.id)"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="法人证件号码" prop="legalPersonCardName">
              <el-input
                  aria-label="法人证件号码"
                  aria-autocomplete="none"
                  clearable
                  maxlength="100"
                  placeholder="请填写法人证件号码"
                  type="text"
                  v-model.trim="form.legalPersonCardName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="证件有效起止时间" prop="legalPersonCardvalidityStart">
              <el-date-picker
                  v-model="form.legalPersonCardvalidityStart"
                  type="date"
                  value-format="timestamp"
                  placeholder="选择日期">
              </el-date-picker>
              至
              <el-date-picker
                  v-model="form.clegalPersonCardvalidityEnd"
                  type="date"
                  value-format="timestamp"
                  placeholder="选择日期">
              </el-date-picker>
              <div class="themeColor">有效期为“长期”时后一项为空</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <div class="flex">
              <el-form-item label="法人证件照" prop="legalPersonPositivePhoto">
                <el-upload
                    class="uploaderFile"
                    accept=".png, .PNG"
                    :action="configBaseURL+'/api/uploadFile'"
                    :data="{type:'legalPersonPhoto'}"
                    :show-file-list="false"
                    :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'legalPersonPositivePhoto')}"
                    :before-upload="beforeUpload"
                >
                  <img
                      v-if="form.legalPersonPositivePhoto"
                      class="file"
                      :src="form.legalPersonPositivePhoto"
                  />
                  <i v-else :class="['el-icon-plus icon',{idCardBackImg:form.legalPersonCertificateType === '1'}]"></i>
                </el-upload>
              </el-form-item>
              <el-form-item prop="legalPersonNegativePhoto" label-width="10px">
                <el-upload
                    class="uploaderFile"
                    accept=".png,.PNG"
                    :action="configBaseURL+'/api/uploadFile'"
                    :data="{type:'legalPersonPhoto'}"
                    :show-file-list="false"
                    :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'legalPersonNegativePhoto')}"
                    :before-upload="beforeUpload"
                >
                  <img
                      v-if="form.legalPersonNegativePhoto"
                      class="file"
                      :src="form.legalPersonNegativePhoto"
                  />
                  <i v-else :class="['el-icon-plus icon',{IDcardFrontImg:form.legalPersonCertificateType === '1'}]"></i>
                </el-upload>
              </el-form-item>
            </div>
            <el-form-item>
              <div class="themeColor">请上传证件正反面图片，图片格式为png，大小不能超过2M。</div>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <!-- 联系人信息 -->
      <div class="subTitle">联系人信息</div>
      <hr class="hr">
      <el-row>
        <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
          <el-form-item label="联系人姓名" prop="contactName">
            <el-input
                aria-label="联系人姓名"
                aria-autocomplete="none"
                clearable
                maxlength="20"
                placeholder="请输入联系人姓名"
                type="text"
                v-model.trim="form.contactName"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
          <el-form-item label="联系人手机号码" prop="contactPhone">
            <el-input
                aria-label="联系人手机号码"
                aria-autocomplete="none"
                clearable
                maxlength="11"
                placeholder="请输入联系手机号码"
                type="text"
                v-model.trim="form.contactPhone"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
          <el-form-item label="联系人邮箱地址" prop="contactEmail">
            <el-input
                aria-label="联系人邮箱地址"
                aria-autocomplete="none"
                maxlength="128"
                clearable
                placeholder="请输入联系人邮箱地址，不超过128个字符"
                type="email"
                v-model.trim="form.contactEmail"
                onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
          <el-form-item label="联系人微信账号" prop="weixin">
            <el-input
                aria-label="联系人微信账号"
                aria-autocomplete="none"
                maxlength="32"
                clearable
                placeholder="请输入联系人微信账号，不超过32个字符"
                type="text"
                v-model.trim="form.weixin"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
          <el-form-item>
            <el-button class="w400" @click="submitForm('form')">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {checkPhone, checkWeixin} from "@/utils/RegExp.js";
import {province} from '@/utils/map.js'

export default {
  props: {
    dataState: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
    legalTypeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  created() {
    this.provincearr = province
    if (this.form.province) this.selectProvince(this.form.province)
    if (this.form.city) this.selectcity(this.form.city)
  },
  data() {
    return {
      provincearr: [],
      cityarr: [],
      regionarr: [],
    };
  },
  computed: {
    rules() {
      return Object.assign({
        province: [
          {required: true, message: "请选择省份", trigger: 'change'},
        ],
        city: [
          {required: true, message: "请选择市", trigger: 'change'},
        ],
        area: [
          {required: true, message: "请选择区", trigger: 'change'},
        ],
        address: [
          {required: true, message: "请填写实际通讯地址", trigger: 'blur'},
        ],
        //联系人信息
        contactName: [
          {required: true, message: "请输入联系人姓名", trigger: "blur"},
        ],
        contactEmail: [
          {required: true, message: "请输入联系人邮箱", trigger: "blur"},
          {type: "email", message: "请输入正确的邮箱地址", trigger: "blur"},
          {validator: this.checkNoCh, trigger: "blur"},
        ],
        contactPhone: [
          {required: true, message: "请输入联系人电话", trigger: "blur"},
          {required: true, validator: checkPhone, trigger: "blur"},
        ],
        weixin: [
          {required: true, message: "请输入联系人微信", trigger: "blur"},
          {required: true, validator: checkWeixin, trigger: "blur"},
        ],
      }, (() => {
        if (this.form.type !== 2) {
          return {
            //基本信息
            companyName: [
              {required: true, message: "请输入企业名称", trigger: "blur"},
            ],
            licinseNumber: [
              {required: true, message: "请填写统一信用社会代码", trigger: "blur"},
            ],
            licinseNumberPhoto: [
              {required: true, message: "请上传相关证件照片", trigger: "blur"},
            ],
            //法人信息
            legalPersonName: [
              {required: true, message: "请输入法人姓名", trigger: "blur"},
            ],
            legalPersonCertificateType: [{required: true, message: '请选择法人证件类型', trigger: 'change'}],
            legalPersonCardName: [
              {required: true, message: "请输入法人证件号码", trigger: "blur"},
              {
                validator: this.form.legalPersonCertificateType !== '1' ? (rule, value, callback)=> callback() : this.validatorPersonNumber, trigger: ['change', 'blur']
              }
            ],
            legalPersonCardvalidityStart: [
              {required: true, message: "请填写证件有效起止时间", trigger: "blur"},
            ],
            legalPersonPositivePhoto: [
              {required: true, message: "请上传法人证件照", trigger: "blur"},
            ],
            legalPersonNegativePhoto: [
              {required: true, message: "请上传法人证件照", trigger: "blur"},
            ],
          }
        } else {
          return {
            name: [
              {required: true, message: "请填写姓名", trigger: "blur"},
            ],
            developId: [
              {required: true, message: "请填写身份证号码", trigger: "blur"},
              {validator: this.validatorPersonNumber, trigger: ['change', "blur"]}
            ],
            developIdValidityStart: [
              {required: true, message: "请填写证件有效期开始时间", trigger: "blur"},
            ],
            developPositivePhoto: [
              {required: true, message: "请上传身份证反面照", trigger: "blur"},
            ],
            developNegativePhoto: [
              {required: true, message: "请上传身份证正面照", trigger: "blur"},
            ],
          }
        }
      })())

    },
  },
  methods: {
    // 邮箱验证
    checkNoCh(rule, value, callback) {
      if (this.value2) {
        let reg = /[\u4E00-\u9FA5]/g;
        if (reg.test(value)) {
          callback(new Error("邮箱不可输入中文"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    // 法人证件号码验证
    validatorPersonNumber(rule, value, callback) {
      if ($utils.checkID(value)) {
        callback()
      }
      return callback(new Error('身份证验证输入有误'));
    },
    selectProvince(name) {
      this.cityarr = [];
      this.regionarr = [];
      this.form.city = '';
      this.form.area = '';
      this.provincearr.forEach(item => {
        if (name == item.name) {
          this.cityarr = item.children
        }
      })
    },
    selectcity(name) {
      this.regionarr = [];
      this.form.area = '';
      this.cityarr.forEach(item => {
        if (name == item.name) {
          // console.log(item.name,'-所选城市')
          this.regionarr = item.children
        }
      })
    },
    selectCountry(name) {
      // this.RegionValue = '';
      // for (let item in this.regionarr) {
      //   console.log(item);
      //   if (id == item.id) {
      //     this.RegionValue = item.children;
      //     // console.log(item.name,'-所选区域')
      //   }
      // }
    },
    changePersonType() {
      if (!this.form.legalPersonCardName) return
      this.$refs.form.validateField('legalPersonCardName')
    },
    //上传前校验
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      const fileName = file.name;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    //上传成功
    handleUpload(res, file, filelist, key) {
      if (res.code == 0) {
        this.form[key] = res.data.link;
        this.$refs.form.validateField(key);
      } else {
        this.$message.error("上传图片大小或尺寸不正确");
      }
    },
    //提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$apis.accountSever.improveData(this.form).then((res) => {
            if (res['code'] == 0) {
              this.$msgBox
                  .alertMessageBox({
                    title: '提示',
                    content:
                        "资料提交成功，请等待工作人员审核，预计将在3个工作日内完成",
                    delayed: 3,
                  })
                  .then((data) => {
                    this.$store
                        .dispatch("accountStore/updateAccountInfo", {})
                        .then((res) => {
                          //去后台拿账户信息，更新本地状态
                          this.$router.push("/account/perfect/status");
                        });
                  })
                  .catch((val) => {
                  });
            } else {
              this.$message.error("提交失败");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.infoForm {
  .subTitle {
    color: #9b9a9a;
    margin-bottom: 15px;

  }

  .hr {
    margin-bottom: 20px;
  }
}

</style>
